/**
 * Skeleton loaders for the MatchPage loading state.
 * Mimics the layout of the actual content to reduce perceived loading time.
 */

const pulse = {
  animation: "skeleton-pulse 1.4s ease-in-out infinite",
};

const glowStyle = (C) => ({
  background: `linear-gradient(90deg, ${C.surface} 25%, ${C.border} 50%, ${C.surface} 75%)`,
  backgroundSize: "200% 100%",
  ...pulse,
  borderRadius: 6,
});

const C = {
  bg: "#0a0f1a",
  surface: "#111827",
  border: "#1e293b",
  muted: "#374151",
};

export function MatchPageSkeleton() {
  return (
    <div style={{ background: C.bg, minHeight: "100vh" }}>
      <style>{`
        @keyframes skeleton-pulse {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>

      {/* Header */}
      <div style={{ background: C.surface, borderBottom: `1px solid ${C.border}`, padding: "20px 24px" }}>
        <div className="max-w-6xl mx-auto">
          <div style={{ ...glowStyle(C), height: 14, width: 160, marginBottom: 20 }} />

          <div className="flex items-center justify-between gap-6">
            {/* Home team */}
            <div className="flex flex-col items-center gap-3">
              <div style={{ ...glowStyle(C), height: 64, width: 64, borderRadius: "50%" }} />
              <div style={{ ...glowStyle(C), height: 16, width: 100 }} />
            </div>

            {/* Score */}
            <div className="flex flex-col items-center gap-2">
              <div style={{ ...glowStyle(C), height: 48, width: 120, borderRadius: 12 }} />
              <div style={{ ...glowStyle(C), height: 14, width: 80 }} />
            </div>

            {/* Away team */}
            <div className="flex flex-col items-center gap-3">
              <div style={{ ...glowStyle(C), height: 64, width: 64, borderRadius: "50%" }} />
              <div style={{ ...glowStyle(C), height: 16, width: 100 }} />
            </div>
          </div>
        </div>
      </div>

      {/* Prediction cards */}
      <div className="max-w-6xl mx-auto px-4 py-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        {[0, 1, 2].map((i) => (
          <div key={i} style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 12, padding: 20 }}>
            <div style={{ ...glowStyle(C), height: 12, width: "60%", marginBottom: 12 }} />
            <div style={{ ...glowStyle(C), height: 36, width: "40%", marginBottom: 16 }} />
            <div style={{ ...glowStyle(C), height: 8, width: "100%", borderRadius: 4 }} />
          </div>
        ))}
      </div>

      {/* Stats bar rows */}
      <div className="max-w-6xl mx-auto px-4 pb-8">
        <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 12, padding: 24 }}>
          <div style={{ ...glowStyle(C), height: 16, width: 200, marginBottom: 20 }} />
          {[0, 1, 2, 3, 4].map((i) => (
            <div key={i} className="flex items-center gap-4 mb-4">
              <div style={{ ...glowStyle(C), height: 10, width: 40, flexShrink: 0 }} />
              <div style={{ ...glowStyle(C), height: 10, flex: 1, borderRadius: 4 }} />
              <div style={{ ...glowStyle(C), height: 10, width: 80, flexShrink: 0 }} />
              <div style={{ ...glowStyle(C), height: 10, flex: 1, borderRadius: 4 }} />
              <div style={{ ...glowStyle(C), height: 10, width: 40, flexShrink: 0 }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
